import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card data-table mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "body-function" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "tbl" }
const _hoisted_6 = { style: {"display":"flex","align-items":"center","justify-content":"center"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_KTModalMenu = _resolveComponent("KTModalMenu")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_button, {
          disabled: _ctx.loading,
          type: "primary",
          plain: "",
          onClick: _ctx.handleOpenAdd,
          size: _ctx.size,
          "data-bs-toggle": "modal",
          "data-bs-target": "#kt_modal_menu"
        }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createElementVNode("i", { class: "fa fa-plus" }, null, -1),
            _createTextVNode(" Thêm quyền")
          ])),
          _: 1
        }, 8, ["disabled", "onClick", "size"])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          size: _ctx.size,
          data: _ctx.menuList,
          "header-row-class-name": "thead-light",
          "row-key": "nMaChucNang",
          style: {"font-size":"1.1rem"},
          height: "100%",
          stripe: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "nMaChucNang",
              label: "Mã chức năng",
              width: "160"
            }),
            _createVNode(_component_el_table_column, {
              prop: "cTenChucNang",
              label: "Tên chức năng",
              "min-width": "160"
            }),
            _createVNode(_component_el_table_column, {
              prop: "cUrl",
              label: "URL"
            }),
            _createVNode(_component_el_table_column, {
              prop: "nLoai",
              label: "Loại",
              align: "center",
              sortable: "",
              width: "160"
            }, {
              default: _withCtx((scope) => [
                (scope.row.nLoai === 1)
                  ? (_openBlock(), _createBlock(_component_el_tag, {
                      key: 0,
                      size: "small"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('menu.tableOfContents')), 1)
                      ]),
                      _: 1
                    }))
                  : (scope.row.nLoai === 2)
                    ? (_openBlock(), _createBlock(_component_el_tag, {
                        key: 1,
                        size: "small",
                        type: "success"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('menu.menu')), 1)
                        ]),
                        _: 1
                      }))
                    : (scope.row.nLoai === 3)
                      ? (_openBlock(), _createBlock(_component_el_tag, {
                          key: 2,
                          size: "small",
                          type: "info"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('menu.button')), 1)
                          ]),
                          _: 1
                        }))
                      : (scope.row.nLoai === 4)
                        ? (_openBlock(), _createBlock(_component_el_tag, {
                            key: 3,
                            size: "small",
                            type: "success"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('menu.external')), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "nThuTu",
              label: "Thứ tự",
              width: "160",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              prop: "cIcon",
              label: "Icon",
              align: "center",
              width: "160"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("i", {
                  class: _normalizeClass(scope.row.cIcon)
                }, null, 2)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              fixed: "right",
              label: "Hành động",
              "header-align": "center",
              width: "150"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_el_button, {
                    size: _ctx.size,
                    type: "primary",
                    disabled: scope.row.delFlag == 1,
                    title: "Sửa",
                    plain: "",
                    onClick: ($event: any) => (_ctx.handleOpenUpdate(scope.row)),
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#kt_modal_menu"
                  }, {
                    default: _withCtx(() => _cache[1] || (_cache[1] = [
                      _createElementVNode("i", { class: "fa fa-wrench" }, null, -1)
                    ])),
                    _: 2
                  }, 1032, ["size", "disabled", "onClick"]),
                  _createVNode(_component_el_button, {
                    size: _ctx.size,
                    title: "Xóa",
                    disabled: scope.row.delFlag == 1,
                    type: "danger",
                    plain: "",
                    onClick: ($event: any) => (_ctx.handleDelete(scope.row))
                  }, {
                    default: _withCtx(() => _cache[2] || (_cache[2] = [
                      _createElementVNode("i", { class: "fa fa-trash" }, null, -1)
                    ])),
                    _: 2
                  }, 1032, ["size", "disabled", "onClick"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["size", "data"])), [
          [_directive_loading, _ctx.loading]
        ])
      ])
    ]),
    _createVNode(_component_KTModalMenu, {
      data: _ctx.dataForm,
      default: _ctx.defaultValues,
      type: (_ctx.dialog.type as number),
      action: _ctx.dialog.action,
      size: _ctx.size,
      table: _ctx.tableData,
      onFinish: _ctx.handleFindPage
    }, null, 8, ["data", "default", "type", "action", "size", "table", "onFinish"])
  ]))
}